import { AxiosCall } from "@/https";

class authService extends AxiosCall {
  url;
  constructor() {
    super();
    this.url = "/login";
  }
  csrf(url_retorno: any) {
    return this.axiosCall({
      method: "get",
      url: `${this.url}/csrf`,
      headers: {
        url_retorno,
      },
    });
  }
  login(data: any, csrf: string) {
    return this.axiosCall({
      method: "post",
      url: `${this.url}`,
      data,
      headers: {
        csrf,
      },
    });
  }
  user() {
    return this.axiosCall({
      method: "get",
      url: `user`,
    });
  }
  register(data: any, csrf: string) {
    return this.axiosCall({
      method: "post",
      url: `user`,
      data,
      headers: {
        csrf,
      },
    });
  }
  uploadImage(data: any, token: string) {
    return this.axiosCall({
      method: "post",
      url: `user/image`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      data,
    });
  }
  validToken() {
    return this.axiosCall({
      method: "get",
      url: "user",
    });
  }
  update(data: any) {
    return this.axiosCall({
      method: "put",
      url: `user/editaccount`,
      data,
    });
  }
  sendEmail(data: any) {
    return this.axiosCall({
      method: "post",
      url: `user/recover`,
      data,
    });
  }
  changePassword(senha: any, token: any) {
    return this.axiosCall({
      method: "post",
      url: `user/recover/${token}`,
      data: { senha },
    });
  }
}

export const apiService = new authService();
